// @flow

// Effect Manager
import { fork, put, select, take } from 'redux-saga/effects'

// Constants
import {
  PROP_SEASON,
  PROP_STATE,
  PROP_CUSTOM,
  PROP_ASSET,
  PROP_PRIMARY_NUTRIENTS,
  PROP_LIMEEQUIVALENT,
  PROP_TARGET_N,
  PROP_TARGET_P,
  PROP_TARGET_K,
  PROP_TARGET_S,
  PROP_PRICE,
  SOLID,
} from 'fc-model-fertilizers'

// Action Types
import { ADD_FERTILIZER } from '../constants'

// Selectors
import operations$ from '../selectors/operations'

// Operator
import fertilizersOperator from 'hfty-operator-fertilizers'

// Exports
export default function *watchFertilizerOperations (): Generator<*, void, *> {
  while (true) {
    const { type, payload } = yield take([ADD_FERTILIZER])
    switch (type) {
      case ADD_FERTILIZER: yield fork(handleAddFertilizer, payload); break
    }
  }
}

export function *handleAddFertilizer (payload: Object): Generator<*, void, *> {
  const operations = yield select(operations$)
  const action = yield fertilizersOperator.actionCreators.cancelOperations(operations)
  yield put(action)
  const operation = fertilizersOperator.create({
    model: {
      [PROP_SEASON]: payload.season,
      [PROP_STATE]: SOLID,
      [PROP_CUSTOM]: 'true',
      [PROP_ASSET]: payload.asset,
      [PROP_PRIMARY_NUTRIENTS]: '',
      [PROP_LIMEEQUIVALENT]: 0,
      [PROP_TARGET_N]: 0,
      [PROP_TARGET_P]: 0,
      [PROP_TARGET_K]: 0,
      [PROP_TARGET_S]: 0,
      [PROP_PRICE]: 0,
    },
  })

  yield put(fertilizersOperator.actionCreators.add(operation))
}
